module.exports = __webpack_public_path__ + "static/media/20_shape_r.26d9a9ae.webp";